import React, { useState } from 'react';
import { CompetitionSearchQuery, SimilarityType } from '../services/DataService';

interface SearchFormProps {
  onSearch: (query: CompetitionSearchQuery) => void;
  onSimilarityTypeChange: (type: SimilarityType) => void;
  selectedSimilarityType: SimilarityType;
  isLoading: boolean;
}

const CompetitionSearchForm: React.FC<SearchFormProps> = ({
  onSearch,
  onSimilarityTypeChange,
  selectedSimilarityType,
  isLoading
}) => {
  const [searchText, setSearchText] = useState('');
  const [tags, setTags] = useState('');
  const [dataDomain, setDataDomain] = useState('');
  const [minParticipants, setMinParticipants] = useState('');
  const [maxParticipants, setMaxParticipants] = useState('');
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const query: CompetitionSearchQuery = {
      text: searchText || undefined,
      tags: tags ? tags.split(',').map(tag => tag.trim()) : undefined,
      dataDomain: dataDomain || undefined,
      minParticipants: minParticipants ? parseInt(minParticipants, 10) : undefined,
      maxParticipants: maxParticipants ? parseInt(maxParticipants, 10) : undefined
    };
    
    onSearch(query);
  };
  
  return (
    <div className="search-form">
      <h2>コンペティション検索</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="searchText">検索テキスト:</label>
          <input
            type="text"
            id="searchText"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="タイトルやサブタイトルで検索"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="tags">タグ (カンマ区切り):</label>
          <input
            type="text"
            id="tags"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
            placeholder="例: classification, tabular data"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="dataDomain">データドメイン:</label>
          <input
            type="text"
            id="dataDomain"
            value={dataDomain}
            onChange={(e) => setDataDomain(e.target.value)}
            placeholder="例: computer vision, economics"
          />
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="minParticipants">最小参加者数:</label>
            <input
              type="number"
              id="minParticipants"
              value={minParticipants}
              onChange={(e) => setMinParticipants(e.target.value)}
              placeholder="例: 1000"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="maxParticipants">最大参加者数:</label>
            <input
              type="number"
              id="maxParticipants"
              value={maxParticipants}
              onChange={(e) => setMaxParticipants(e.target.value)}
              placeholder="例: 10000"
            />
          </div>
        </div>
        
        <div className="form-group">
          <label>類似性の観点:</label>
          <div className="radio-group">
            <label>
              <input
                type="radio"
                name="similarityType"
                checked={selectedSimilarityType === SimilarityType.TITLE}
                onChange={() => onSimilarityTypeChange(SimilarityType.TITLE)}
              />
              タイトル
            </label>
            
            <label>
              <input
                type="radio"
                name="similarityType"
                checked={selectedSimilarityType === SimilarityType.TAGS}
                onChange={() => onSimilarityTypeChange(SimilarityType.TAGS)}
              />
              タグ
            </label>
            
            <label>
              <input
                type="radio"
                name="similarityType"
                checked={selectedSimilarityType === SimilarityType.DATA_DOMAIN}
                onChange={() => onSimilarityTypeChange(SimilarityType.DATA_DOMAIN)}
              />
              データドメイン
            </label>
            
            <label>
              <input
                type="radio"
                name="similarityType"
                checked={selectedSimilarityType === SimilarityType.ALL}
                onChange={() => onSimilarityTypeChange(SimilarityType.ALL)}
              />
              すべて
            </label>
          </div>
        </div>
        
        <button type="submit" disabled={isLoading}>
          {isLoading ? '検索中...' : '検索'}
        </button>
      </form>
    </div>
  );
};

export default CompetitionSearchForm;
